<template>
	<div class="row">
		<div class="col">
			<h4>Selected</h4>
			<draggable :disabled="disabled" class="bg-light p-2 rounded drag-area" :list="selected" group="selected"
					   handle=".cursor-grabbable" @change="toggleItem">
				<slot :item="item" v-for="(item, index) in selected"></slot>
			</draggable>
		</div>
		<div class="col">
			<h4>Available</h4>
			<draggable :disabled="disabled" class="bg-light p-2 rounded drag-area" :list="notSelectedOptions"
					   handle=".cursor-grabbable" group="selected">
				<slot class="cursor-grabbable" :item="item" v-for="(item, index) in notSelectedOptions"></slot>
			</draggable>
		</div>

	</div>
</template>

<script>
	export default {
		props: {
			selected: {
				type: Array,
				default: () => []
			},
			options: {
				type: Array,
				default: () => []
			},
			itemKey: {
				type: String,
				default: 'Id'
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			async toggleItem(e) {
				console.log(`toggleItem`, e)
				this.$nextTick(() => {
					if (e.added !== undefined) {
						this.$emit('add', e.added.element)
					} else if (e.removed !== undefined) {
						this.$emit('remove', e.removed.element)
					}
				})
				return false
			}
		},
		computed: {
			notSelectedOptions() {
				return this.options.filter(o => !this.selectedIds.includes(o[this.itemKey]))
			},
			selectedIds() {
				return this.selected.map(m => m[this.itemKey])
			}
		}
	}
</script>

<style scoped lang="scss">
	.drag-area {
		min-height: 200px;
	}
</style>
